<htc-dialog
  [useBackground]="false"
  [useWideMode]="true"
  theme="expandable-content-dialog"
  (showPopupChange)="onPopupChange()"
  data-testid="htc-expandable-content-popup">
  <section class="content-container">
    <ngx-skeleton-loader
      [hidden]="loaded"
      appearance="circle"
      [count]="1"
      animation="pulse"
      [theme]="{
        width: 'calc(100% - 0.5rem)',
        height: '80vh',
        'border-radius': '0.3125rem'
      }"
      data-testid="htc-expandable-content-skeleton"></ngx-skeleton-loader>
    <div [hidden]="!loaded">
      @if (expandableContent && expandableContent.chart.data) {
        <htc-chart
          data-testid="htc-expanded-chart"
          [data]="expandableContent.chart.data"
          [isDataUrl]="expandableContent.chart.isUrl"
          (chartLoaded)="onLoaded()"
          [fitToParentElement]="true"></htc-chart>
      } @else if (expandableContent && expandableContent.imageSrc) {
        <img
          data-testid="htc-expanded-image"
          [src]="expandableContent.imageSrc | cdnSrcBaseUrl"
          [alt]="expandableContent.imageAlt | altTextLang"
          (load)="onLoaded()"
          (error)="onLoaded()" />
      }
    </div>
  </section>
</htc-dialog>
